import { useEffect, useState } from "react";

import { Box } from "@mui/material";

import useSurvey from "../../hooks/useSurvey";

const QuestionStatus = ({ question, answer, location }) => {
  const { getQuestionStatus } = useSurvey();

  const [questionStatus, setQuestionStatus] = useState("#ccc");

  useEffect(() => {
    const getStatus = async () => {
      const status = await getQuestionStatus(question, answer, location);
      // Map percentComplete/required into a color (align with mobile Status)
      if (status?.colorCode) {
        setQuestionStatus(status);
        return;
      }

      if (!status) {
        setQuestionStatus({ colorCode: "#ccc" });
        return;
      }

      const color =
        status.percentComplete === 1
          ? "#00ff00"
          : status.isRequired
            ? "#ff0000"
            : "#ffff00";

      setQuestionStatus({ ...status, colorCode: color });
    };

    getStatus();
  }, [answer, question, location]);

  return (
    <Box
      sx={{
        width: "5px",
        height: "5px",
        backgroundColor: questionStatus.colorCode,
        margin: "1px",
        borderRadius: "50%",
      }}
    ></Box>
  );
};

export default QuestionStatus;
